export const blue = "#497b99";
export const debounceTimeInMs = 250;

export const LoggedOutReasons = {
    NotAuthorized: "not_authorized"
};